<template>
  <div class="progress-container">
    <div class="progress-bar" :style="{ width: progress + '%' }"></div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  progress: {
    type: Number,
    required: true,
  },
});
</script>

<style>
/* Styles moved to base.css - using CSS variables for responsive scaling */
</style>
